import { stripIcon, type StripItem } from "../lib/actionStrip";
import { Icon } from "./Icon";

/**
 * 🔴 W119 — THE ONE HOVER-ACTION STRIP (William, 2026-10-01 ~00:40: *"they could be as buttons and not just text, without
 * this middle dot … the edit, copy and delete just icon buttons? so a pencil, a copy icon and a trash can?"*). Every row
 * that shows actions on hover draws them HERE — the Workouts list, the Clients roster, the Exercises shelf and the client
 * Week card's overlay — so the four can never drift into four grammars.
 *
 * A word is a quiet outlined button (`.ht-button`, neutral) with its word; an edit-class action (`stripIcon`: Edit, Copy,
 * Delete / Remove) is an ICON button of the same height whose name is its `aria-label` and its `title` tooltip. A
 * destructive one wears the destructive ink and does exactly what its caller's handler does — the confirm stays the
 * caller's. No separators: the buttons are their own edges. What reveals the strip (hover, focus, always) is the surface's
 * CSS, never this component — it is never mounted on hover, so a row cannot change height.
 */
export function ActionStrip({ items, className = "", label: groupLabel }: {
  items: readonly StripItem[];
  className?: string;
  /** The group's accessible name, so a screen reader hears WHICH row's actions (`Actions for Push A`). */
  label?: string;
}) {
  if (items.length === 0) return null;
  return (
    <span className={className === "" ? "act-strip" : `act-strip ${className}`} role="group" aria-label={groupLabel}>
      {items.map((it) => <StripAction key={it.key} it={it} />)}
    </span>
  );
}

function StripAction({ it }: { it: StripItem }) {
  const icon = stripIcon(it.key);
  const label = it.label;
  const className = `ht-button act ${icon === null ? "act-word" : "act-icon"}${it.destructive === true ? " is-destructive" : ""}`;
  if (icon !== null) {
    const glyph = <Icon name={icon} size={16} />;
    return it.href !== undefined
      ? <a className={className} href={it.href} aria-label={label} title={label}>{glyph}</a>
      : <button type="button" className={className} disabled={it.disabled} onClick={it.onClick} aria-label={label} title={label}>{glyph}</button>;
  }
  return it.href !== undefined
    ? <a className={className} href={it.href}>{label}</a>
    : <button type="button" className={className} disabled={it.disabled} onClick={it.onClick}>{label}</button>;
}
